import * as React from "react";
import {  Container, Row } from "reactstrap";
import './CenteredContent.scss';

class CenteredContent extends React.Component<any> {
  render() {
    const { className, children } = this.props;
    return (
      <div
        className={
          "d-flex flex-row align-items-center min-vh-100 centered-content " +
          window.brandConfig.theme +
          (className ? ` ${className}` : "")
        }
      >
        <Container>
          <Row>{children}</Row>
        </Container>
        {(!window.brandConfig.companyLogo || window.brandConfig.companyLogo.toLowerCase() != 'none') && (
          <div id="footer">
            <a id="footer-logo" className="d-inline-block" href="https://www.marbes.cz" target="_blank" rel="noopener">
                <span className="sr-only">Marbes</span>
            </a>
          </div>
        )}
      </div>
    );
  }
}

export default CenteredContent;
